import httpService from "../_utils/http-service";
import { traceEvent } from "../_utils/analytics-utils";

export const verifyEmail = ({ email, token }, callback) => {
  return function(dispatch) {
    httpService
      .post("/customers/email/verify", { email, token })
      .then(res => {
        if (res.data.statusCode === 200) {
          traceEvent("email", "verify success");
          callback({ success: true });
        } else {
          traceEvent("error", "verifyEmail");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "verifyEmail");
        callback({ success: false });
      });
  };
};
